import { ReactElement, useEffect, useMemo, useState } from "react";
import { Property } from "../../../contexts/properties/logic";
import { DateSelector } from "./DateSelector";
import { Dropdown, Field, Item, Label, Menu, Select } from "@zendeskgarden/react-dropdowns";
import { MONTHS } from "../../../constants/Months";
import { ensureDateInLocale } from '../../../components/analyst-payroll-drawer/date-helpers';


export interface IPayrollDateFilterProps {
    property: Property | undefined;
    once: Date[];
    recurring: {month: number, day: number}[];
    onSelectOnce: (d: Date) => void;
    onSelectRecurring: (month: number, day: number) => void;
    onSelectAny: () => void;
}

export default function PayrollDateFilter({
    property,
    once,
    recurring,
    onSelectOnce,
    onSelectRecurring,
    onSelectAny,
}: IPayrollDateFilterProps): ReactElement {
    const [selectedOption, setSelectedOption] = useState<{label: string, value: string}>({label: "Any", value: "any"});

    const acqPropOptions = useMemo(() => {
        const dateOptions = [{label: "Any", value: "any"}];

        if (property && property.acquisitionBudgetStartMonth != null && property.acquisitionBudgetYear != null) {
            let periodLabel = "T12";
            let year = property.acquisitionBudgetYear - 1;

            for (let i = 0; i < 24; i++) {
                const month = (property.acquisitionBudgetStartMonth + i) % 12;
                dateOptions.push({
                    label: `${MONTHS[month]} ${periodLabel}`,
                    value: `${year}-${month + 1}-01`,
                });

                if (dateOptions.length == 13) {
                    periodLabel = "Year 1";
                }

                if (month == 11) {
                    year += 1;
                }
            }
        }

        return dateOptions;
    }, [property]);

    useEffect(() => {
        const dateInLocale = ensureDateInLocale(selectedOption.value);

        if (selectedOption.value == "any") {
            onSelectAny();
        } else if (dateInLocale) {
            onSelectOnce(dateInLocale);
        }
    }, [selectedOption]);

    if (!property) {
        return <></>;
    }

    if (property.isAcquisitionProperty) {
        return (
            <Dropdown
                selectedItem={selectedOption}
                onSelect={setSelectedOption}
                downshiftProps={{itemToString: (item: { label: string, value: string }) => item && item.label}}
            >
                <Field>
                    <Label hidden>Filter Employees by Date</Label>
                    <Select>{selectedOption.label}</Select>
                </Field>
                <Menu>
                    {acqPropOptions.map(option => (
                        <Item key={option.value} value={option}>
                            {option.label}
                        </Item>
                    ))}
                </Menu>
            </Dropdown>
        );
    }

    return (
        <DateSelector
            once={once}
            recurring={recurring}
            onSelectOnce={onSelectOnce}
            onSelectRecurring={onSelectRecurring}
            onSelectAny={onSelectAny}
        />
    );
}